import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

const STATUS_STYLES = {
    new: "bg-gold/15 text-gold border-gold/30",
    read: "bg-surface2 text-ash border-gold/15",
    resolved: "bg-moss/25 text-cream border-moss/40",
};

function Card({ m, onStatus }) {
    const st = m.status || "new";
    return (
        <div className="p-4 rounded-xl bg-surface border border-gold/10" data-testid={`msg-${m.id}`}>
            <div className="flex items-start justify-between gap-4">
                <div>
                    <div className="text-cream text-sm">{m.name} · <span className="text-ash">{m.email}</span></div>
                    {m.subject && <div className="text-xs text-gold mt-0.5">{m.subject}</div>}
                </div>
                <div className="flex items-center gap-2 shrink-0">
                    <span className={`text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full border ${STATUS_STYLES[st]}`}>{st}</span>
                    <span className="text-xs text-faded">{new Date(m.created_at).toLocaleDateString()}</span>
                </div>
            </div>
            <p className="text-sm text-ash mt-2 whitespace-pre-line">{m.message}</p>
            <div className="mt-3 flex gap-2">
                {st === "new" && <button onClick={() => onStatus(m.id, "read")} data-testid={`mark-read-${m.id}`} className="text-xs text-ash border border-gold/20 rounded-full px-3 py-1 hover:text-gold">Mark read</button>}
                {st !== "resolved" && <button onClick={() => onStatus(m.id, "resolved")} data-testid={`mark-resolved-${m.id}`} className="text-xs text-gold border border-gold/30 rounded-full px-3 py-1 hover:bg-gold/10">Resolve</button>}
                {st === "resolved" && <button onClick={() => onStatus(m.id, "new")} className="text-xs text-ash border border-gold/20 rounded-full px-3 py-1 hover:text-gold">Reopen</button>}
            </div>
        </div>
    );
}

export default function AdminMessages() {
    const [msgs, setMsgs] = useState([]);
    const load = () => api.get("/admin/contact").then((r) => setMsgs(r.data));
    useEffect(() => { load(); }, []);

    const onStatus = async (id, status) => {
        await api.put(`/admin/contact/${id}/status?status=${status}`);
        toast.success(`Marked ${status}`);
        load();
    };

    const contact = msgs.filter((m) => (m.type || "contact") === "contact");
    const land = msgs.filter((m) => m.type === "land_defense");

    return (
        <div>
            <h1 className="font-serif text-4xl text-cream mb-6">Messages</h1>
            <Tabs defaultValue="contact">
                <TabsList className="bg-surface2 border border-gold/15">
                    <TabsTrigger value="contact" className="data-[state=active]:bg-gold data-[state=active]:text-ink">Contact ({contact.length})</TabsTrigger>
                    <TabsTrigger value="land" className="data-[state=active]:bg-gold data-[state=active]:text-ink">Land Defense ({land.length})</TabsTrigger>
                </TabsList>
                <TabsContent value="contact" className="mt-6 space-y-3" data-testid="admin-contact">
                    {contact.map((m) => <Card key={m.id} m={m} onStatus={onStatus} />)}
                    {contact.length === 0 && <p className="text-ash">No messages yet.</p>}
                </TabsContent>
                <TabsContent value="land" className="mt-6 space-y-3" data-testid="admin-land">
                    {land.map((m) => <Card key={m.id} m={m} onStatus={onStatus} />)}
                    {land.length === 0 && <p className="text-ash">No land-defense inquiries yet.</p>}
                </TabsContent>
            </Tabs>
        </div>
    );
}
